<template>
  <div id="sidebar">
    <h4 class="mt-4 mb-0 p-3 text-center text-white catalog-hd">最新</h4>
    <ul class="list-group catalog-list-group">
      <li class="list-group-item " style="font-size: 14px;" v-for="(item,index) in articles0" :key="item.id"><span class="float-left hot-num">{{index+1}}</span><a class="" :href="detailUrl + item.id" :title="item.digest">{{item.title}}</a></li>
    </ul>
  </div>
</template>

<script>
  const axios = require('axios')
  export default {
    name: 'sidebar',
    data () {
      return {
        categorys: null,
        category1: null,
        articles0: [{}],
        detailUrl: '/article/details/'
      }
    },
    mounted() {
      let that = this
      // 首页栏目列表
      axios.get(that.global.apiUrl + '/web/channel/listAll')
        .then(function (response) {
          if (response.data.success && response.data.data.length > 0) {
            that.categorys = response.data.data
            for (var index in that.categorys) {
              // 新闻动态
              if (that.categorys[index].code == 'news') {
                for (var n in that.categorys[index].children) {
                  // 校园新闻
                  if (that.categorys[index].children[n].code == 'schoolnews') {
                    that.category1 = that.categorys[index].children[n]
                  }
                }
              }
            }
            // 校园动态
            axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=5&idChannel=' + that.category1.id + '&sort=id&order=desc')
              .then(function (response) {
                // console.log(response.data.data.records)
                if (response.data.success && response.data.data.records.length > 0) {
                  that.articles0 = response.data.data.records
                  for (var index in that.articles0) {
                    const item = that.articles0[index]
                    item.digest = item.title
                    item.title = item.title.length > 20 ? item.title.substring(0, 20) + '...' : item.title
                    item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
                  }
                }
              })

          }

        })
    }
  }
</script>

<style>
  .hot-num {
    width: 36px;
    height: 36px;
    float: left;
    background-color: #0050a5;
    font-family: 'Arial';
    font-size: 24px;
    color: #fff;
    text-align: center;
    margin-top: 5px;
    margin-right: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/views/sidebar/sidebar.vue